import { Col, Container, Row } from "react-bootstrap";
import { SkeletonBox } from "../../components/skeleton-box";

export default function SubscriptionSkeletonLoader() {
    return (
        <Container className="mt-2">
            <Row className="justify-content-start bg-white border food-border-rounded p-3 flex-column">
                <Col className="d-flex justify-content-between">
                    <SkeletonBox style={{ width: "300px", height: "30px" }} />
                    <SkeletonBox style={{ width: "300px", height: "30px" }} />
                </Col>
                <Col className="mt-3">
                    <SkeletonBox style={{ width: "200px", height: "20px" }} />
                </Col>
                <Col>
                    <SkeletonBox style={{ width: "100%", height: "400px" }} />
                </Col>
                <Col className="d-flex justify-content-center mt-3">
                    <SkeletonBox style={{ width: "400px", height: "40px" }} />
                </Col>
            </Row>
        </Container>
    );
}
